export default "__VITE_ASSET__d7c3ea7d__"